import request from './request'

/**
 * 查询首页展示信息（图片 + 通知公告）
 * @returns {Promise} data 为：
 *   {
 *     imageUrls: [     // 首页展示图片链接数组
 *       "https://www.ttxb.cn/lucky-num/image_419090010192399.png"
 *     ],
 *     noticeContent: [ // 通知公告内容数组，逐条展示
 *       "重要通知111111111111111111111111111111111111",
 *       "重要通知22222222222222222222222222222"
 *     ]
 *   }
 */
export function getDisplayInfo() {
  return request({
    url: '/system/display',
    method: 'post'
  })
}
